import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==========================================
// 1. LIGHT GROUPINGS
// ==========================================
export const LIGHT_GROUPS = {
    // Standard Universal Rails (Gets APLc Universal)
    UNIVERSAL_STD: [
        "x300u_a", "x300u_b", "tlr1", "tlr1_hlx", "tlr7", "tlr7_hlx", 
        "inforce_apl", "inforce_apl_3", "inforce_wild1", "inforce_aplc_uni",
        "olight_pl_mini", "olight_pl_mini2", "olight_pl2", "olight_pl_pro", 
        "surefire_xc1b", "surefire_xc1c", "surefire_xc3",
        "sig_foxtrot1x", "sig_foxtrot2r" // Mirrored from IWB Builder
    ],
    // Glock & Specific CZs (Gets APLc Glock)
    UNIVERSAL_GLOCK_CZ: [
        "x300u_a", "x300u_b", "tlr1", "tlr1_hlx", "tlr7", "tlr7_hlx", 
        "inforce_apl", "inforce_apl_3", "inforce_wild1", "inforce_aplc_glock",
        "olight_pl_mini", "olight_pl_mini2", "olight_pl2", "olight_pl_pro", 
        "surefire_xc1b", "surefire_xc1c", "surefire_xc3",
        "sig_foxtrot1x", "sig_foxtrot2r" // Mirrored from IWB Builder
    ],
    SUB_GLOCK: ["tlr7_sub_glock", "surefire_xsc_a", "tlr6"],
    SUB_SIG: ["tlr7_sub_p365", "sig_foxtrot2r", "surefire_xsc", "tlr6"],
    SUB_SIG_MACRO: ["tlr7_sub_1913", "sig_foxtrot2r", "tlr6"],
    SUB_1913: ["tlr7_sub_1913"],
    TLR6_ONLY: ["tlr6"]
};

export const holsterData = {
  // --- BRANDS ---
  brands: [
    { id: "1911", name: "1911" },
    { id: "arex", name: "AREX" },
    { id: "beretta", name: "Beretta" },
    { id: "browning", name: "Browning" },
    { id: "canik", name: "Canik" },
    { id: "cz", name: "CZ" },
    { id: "fn", name: "FN" },
    { id: "glock", name: "Glock" },
    { id: "hk", name: "H&K" },
    { id: "icarus", name: "Icarus Precision" },
    { id: "iwi", name: "IWI" },
    { id: "kahr", name: "Kahr" },
    { id: "kimber", name: "Kimber" },
    { id: "p80", name: "Polymer80" },
    { id: "rost_martin", name: "Rost Martin" },
    { id: "ruger", name: "Ruger" },
    { id: "sccy", name: "SCCY" },
    { id: "shadow_systems", name: "Shadow Systems" },
    { id: "sig", name: "Sig Sauer" },
    { id: "sw", name: "Smith & Wesson" },
    { id: "sphinx", name: "SPHINX" },
    { id: "springfield", name: "Springfield Armory" },
    { id: "staccato", name: "Staccato" },
    { id: "steyr", name: "Steyr" },
    { id: "taurus", name: "Taurus" },
    { id: "walther", name: "Walther" }
  ],

  // --- GUN MODELS ---
  guns: [
    // 1911
    { id: "1911_govt_nr", brand_id: "1911", name: "1911 Govt 5\" Non-Rail (NO Sig 1911)", supported_lights: [] },
    { id: "1911_govt_rail", brand_id: "1911", name: "1911 Standard Government 5\" w/ Rail (DOES NOT FIT Sig 1911)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "1911_cmdr_rail", brand_id: "1911", name: "1911 4.25\" Commander w/ Rail (NO Sig)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "1911_cmdr_nr", brand_id: "1911", name: "1911 4.25\" Commander Non-Rail (NO Sig)", supported_lights: [] },
    { id: "1911_ultra", brand_id: "1911", name: "1911 3\" Ultra Carry (NO Sig 1911)", supported_lights: [] },

    // AREX
    { id: "arex_alpha", brand_id: "arex", name: "AREX Alpha", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "arex_delta", brand_id: "arex", name: "AREX Delta (1.0 / 2.0 M)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "arex_delta_l", brand_id: "arex", name: "AREX Delta L", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "arex_zero1_cp", brand_id: "arex", name: "AREX Zero 1 CP/TC", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "arex_zero1", brand_id: "arex", name: "AREX Zero 1", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "arex_zero1_tac", brand_id: "arex", name: "AREX Zero 1 Tactical", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // BERETTA
    { id: "beretta_92_series", brand_id: "beretta", name: "Beretta 92FS, M9, and M9A3", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "beretta_m9a1", brand_id: "beretta", name: "Beretta M9A1", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "beretta_m9a4", brand_id: "beretta", name: "Beretta M9A4", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "beretta_px4", brand_id: "beretta", name: "Beretta PX4 Storm", supported_lights: ["tlr7"] },
    { id: "beretta_px4_c", brand_id: "beretta", name: "Beretta PX4 Storm Compact", supported_lights: [] },
    
    // BROWNING
    { id: "browning_hp", brand_id: "browning", name: "Browning Hi-Power 9mm", supported_lights: [] },

    // CANIK
    { id: "canik_tp9sa", brand_id: "canik", name: "Canik TP9SA", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "canik_tp9sf", brand_id: "canik", name: "Canik TP9SF", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "canik_elite", brand_id: "canik", name: "Canik TP9SF ELITE", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "canik_sfx", brand_id: "canik", name: "Canik TP9SFX", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "canik_tti", brand_id: "canik", name: "Canik TTI Combat", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // CZ
    { id: "cz_p01", brand_id: "cz", name: "CZ P01", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "cz_p07", brand_id: "cz", name: "CZ P-07", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_p09", brand_id: "cz", name: "CZ P-09", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_p10c", brand_id: "cz", name: "CZ P-10 C", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "cz_p10f", brand_id: "cz", name: "CZ P-10 F", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_p10s", brand_id: "cz", name: "CZ P-10 S", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_rami", brand_id: "cz", name: "CZ 2075 Rami", supported_lights: [] },
    { id: "cz_75b", brand_id: "cz", name: "CZ 75 B (9MM ONLY)", supported_lights: [] },
    { id: "cz_75_compact", brand_id: "cz", name: "CZ 75 Compact", supported_lights: [] },
    { id: "cz_75d_pcr", brand_id: "cz", name: "CZ 75 D Compact PCR", supported_lights: [] },
    { id: "cz_97b", brand_id: "cz", name: "CZ 97B", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_shadow2", brand_id: "cz", name: "CZ Shadow 2", supported_lights: [...LIGHT_GROUPS.UNIVERSAL_STD, "tlr7_sub_1913"] },
    { id: "cz_shadow2_carry", brand_id: "cz", name: "CZ Shadow 2 Carry", supported_lights: [...LIGHT_GROUPS.UNIVERSAL_STD, "tlr7_sub_1913"] },
    { id: "cz_shadow2_compact", brand_id: "cz", name: "CZ Shadow 2 Compact", supported_lights: [...LIGHT_GROUPS.UNIVERSAL_STD, "tlr7_sub_1913"] },
    { id: "cz_sp01_tac", brand_id: "cz", name: "CZ-75 SP01 Tactical", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "cz_sp01_phantom", brand_id: "cz", name: "CZ SP01 Phantom", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // FN
    // FN
    { id: "fn_309", brand_id: "fn", name: "FN 309", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [] },
    { id: "fn_57_old", brand_id: "fn", name: "FN 5.7 (Fits Mk1/Mk2)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_57", brand_id: "fn", name: "FN 5.7 Mk3", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_502", brand_id: "fn", name: "FN 509/502 (Fits Tactical Models)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_503", brand_id: "fn", name: "FN 503", supported_lights: [] },
    { id: "fn_509c", brand_id: "fn", name: "FN 509C / 509C Tactical", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_509", brand_id: "fn", name: "FN 509 / 509M", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_509_tac", brand_id: "fn", name: "FN 509 Tactical", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    // No custom builds on either EDGE model — quick-ship RH non-lightbearing only.
    // LH was previously custom-only, so it is removed entirely.
    { id: "fn_509_cc", brand_id: "fn", name: "FN 509 CC EDGE", qs_nlb_rh: true, supported_lights: [], no_left_hand: true },
    { id: "fn_509_ls", brand_id: "fn", name: "FN 509 LS EDGE", qs_nlb_rh: true, supported_lights: [], no_left_hand: true },
    { id: "fn_510", brand_id: "fn", name: "FN 510/545 TACTICAL", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_fns9", brand_id: "fn", name: "FN FNS 9", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_fnx45", brand_id: "fn", name: "FN FNX45/TACTICAL", qs_nlb_rh: true, supported_lights: [...LIGHT_GROUPS.UNIVERSAL_STD, "sig_foxtrot2r"] },
    { id: "fn_fnx9", brand_id: "fn", name: "FN FNX 9", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_high_power", brand_id: "fn", name: "FN HIGH POWER (2022)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_fns9_c", brand_id: "fn", name: "FNS 9 Compact", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "fn_reflex", brand_id: "fn", name: "FN REFLEX/XL MRD", qs_nlb_rh: true, supported_lights: [] },

    // GLOCK
    { id: "glock17", brand_id: "glock", name: "Glock 17/31 (FITS: GEN 3-6, 17M, 17 MOS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock19", brand_id: "glock", name: "Glock 19/23/32 (FITS: GEN 3-6, 19M, 19X, G45, 19 MOS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock20_21_gen24", brand_id: "glock", name: "Glock 20/21/21SF (Gen 2-4 ONLY)", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock20_21_gen5", brand_id: "glock", name: "Glock 20/21 (Gen 5 ONLY)", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock22_gen24", brand_id: "glock", name: "Glock 22 (Gen 2-4 ONLY)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock22_gen5", brand_id: "glock", name: "Glock 22 (Gen 5)", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock23_gen5", brand_id: "glock", name: "Glock 23 (Gen 5)", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock26", brand_id: "glock", name: "Glock 26 / 27 / 33", supported_lights: [] },
    { id: "glock30", brand_id: "glock", name: "Glock 30 / 29 / 29s", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock30s", brand_id: "glock", name: "Glock 30S", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock34", brand_id: "glock", name: "Glock 34/35 (FITS: GEN 3-6, MOS)", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock36", brand_id: "glock", name: "Glock 36", supported_lights: [] /* custom lead time only - no quick ship */ },
    { id: "glock40", brand_id: "glock", name: "Glock 40", supported_lights: LIGHT_GROUPS.UNIVERSAL_GLOCK_CZ },
    { id: "glock42", brand_id: "glock", name: "Glock 42", supported_lights: LIGHT_GROUPS.TLR6_ONLY },
    { id: "glock43", brand_id: "glock", name: "Glock 43", supported_lights: LIGHT_GROUPS.TLR6_ONLY },
    { id: "glock43x", brand_id: "glock", name: "Glock 43X (Includes MOS models)", supported_lights: LIGHT_GROUPS.SUB_GLOCK },
    { id: "glock_43_15rd", brand_id: "glock", name: "GLOCK 43/43X (Includes MOS) w/ 15 Rnd Factory Mag", supported_lights: LIGHT_GROUPS.SUB_GLOCK },
    { id: "glock48", brand_id: "glock", name: "Glock 48 (Includes MOS models)", supported_lights: LIGHT_GROUPS.SUB_GLOCK },
    { id: "glock_48_15rd", brand_id: "glock", name: "GLOCK 48 (Includes MOS) w/ 15 Rnd Factory Mag", supported_lights: LIGHT_GROUPS.SUB_GLOCK },

    // HK
    { id: "hk_cc9", brand_id: "hk", name: "HK CC9", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [] },
    { id: "hk_p2000", brand_id: "hk", name: "H&K P2000", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD.filter(id => !["x300u_a", "x300u_b", "tlr1", "tlr1_hlx"].includes(id)) },
    { id: "hk_p2000sk", brand_id: "hk", name: "H&K P2000SK", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_p30", brand_id: "hk", name: "H&K P30", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_p30l", brand_id: "hk", name: "H&K P30L", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_p30sk", brand_id: "hk", name: "H&K P30SK", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_45", brand_id: "hk", name: "H&K 45", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_vp9", brand_id: "hk", name: "H&K VP9/A1-K (4.09\")", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_vp9_l", brand_id: "hk", name: "H&K VP9 A1-F (4.53\")", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_vp9cc", brand_id: "hk", name: "H&K VP9CC", supported_lights: ["tlr7_sub_1913"] /* Surefire XSC-B removed */ },
    { id: "hk_vp9sk", brand_id: "hk", name: "H&K VP9SK", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "hk_vp40", brand_id: "hk", name: "H&K VP40", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // ICARUS
    { id: "icarus_air", brand_id: "icarus", name: "Icarus AIR (XMacro Length)", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [] },

    // IWI
    { id: "iwi_masada", brand_id: "iwi", name: "IWI Masada", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "iwi_masada_slim", brand_id: "iwi", name: "IWI Masada Slim", supported_lights: [] /* custom lead time only - no quick ship */ },
    { id: "iwi_masada_slim_elite", brand_id: "iwi", name: "IWI Masada Slim Elite", supported_lights: ["tlr7_sub_1913"] /* custom lead time only - no quick ship */ },

    // KAHR
    { id: "kahr_cm9", brand_id: "kahr", name: "Kahr CM9", supported_lights: [] },

    // KIMBER
    { id: "kimber_evo", brand_id: "kimber", name: "Kimber EVO SP", supported_lights: [] },

    // P80
    { id: "p80_pf940c", brand_id: "p80", name: "P80 PF940C *Brownells Slides Not Compatible*", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "p80_pf940v2", brand_id: "p80", name: "P80 PF940v2 (17 Length) *Brownells Slides Not Compatible*", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "p80_pf940sc", brand_id: "p80", name: "P80 PF940SC", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "p80_pf940cl", brand_id: "p80", name: "P80 PF940CL", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // ROST MARTIN
    { id: "rost_martin_rm1c", brand_id: "rost_martin", name: "Rost Martin RM1C", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // RUGER
    { id: "ruger_lc9", brand_id: "ruger", name: "Ruger LC9", supported_lights: [] },
    { id: "ruger_lcp", brand_id: "ruger", name: "Ruger LCP", supported_lights: [] },
    { id: "ruger_lcp2", brand_id: "ruger", name: "Ruger LCPII", supported_lights: [] },
    { id: "ruger_sr22", brand_id: "ruger", name: "Ruger SR22 (standard length, not long slide)", supported_lights: [] },
    { id: "ruger_sr940", brand_id: "ruger", name: "Ruger SR 9/SR 40", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "ruger_sr940c", brand_id: "ruger", name: "Ruger SR9/40 Compact", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // SCCY
    { id: "sccy_cpx", brand_id: "sccy", name: "SCCY CPX-1 / CPX-2 / CPX-3", supported_lights: [] },
    { id: "sccy_dvg", brand_id: "sccy", name: "SCCY DVG-1RD", supported_lights: [] },

    // SHADOW SYSTEMS
    { id: "ss_mr920", brand_id: "shadow_systems", name: "Shadow Systems MR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },
    { id: "ss_mr920l", brand_id: "shadow_systems", name: "Shadow Systems MR920L", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },
    { id: "ss_xr920", brand_id: "shadow_systems", name: "Shadow Systems XR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },
    { id: "ss_dr920", brand_id: "shadow_systems", name: "Shadow Systems DR920", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },
    { id: "ss_dr920p", brand_id: "shadow_systems", name: "Shadow Systems DR920P", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },
    { id: "ss_dr920l", brand_id: "shadow_systems", name: "Shadow Systems DR920L", qs_nlb_rh: true, qs_nlb_lh: true, qs_lb_rh: ["x300u_a", "x300u_b"], qs_lb_lh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"] },

    // SIG SAUER
    { id: "sig_1911_xfull", brand_id: "sig", name: "Sig 1911 X-FULL 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_1911_xcarry", brand_id: "sig", name: "Sig 1911 X-CARRY 4.25\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_1911_tacops_nr", brand_id: "sig", name: "Sig 1911 5\" TACOPS/SCORPION (No Rail)", supported_lights: [] },
    { id: "sig_1911_tacops_r", brand_id: "sig", name: "Sig 1911 5\" TACOPS/SCORPION/NIGHTMARE", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_2022_gen1", brand_id: "sig", name: "Sig 2022 (3-slot rail, GEN1)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_2022_gen2", brand_id: "sig", name: "Sig P2022 Gen2", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p220_rail", brand_id: "sig", name: "Sig P220 w/ Rail (DOES NOT FIT P220 COMBAT)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p226_mk25", brand_id: "sig", name: "Sig P226 Mk25", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD /* custom lead time only - no quick ship */ },
    { id: "sig_p226_xcarry_legion", brand_id: "sig", name: "SIG P226-XCarry Legion (3.8\")", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD.filter(id => id !== "surefire_xc3") },
    { id: "sig_p226_x_legion", brand_id: "sig", name: "SIG P226-X Legion (4.4\")", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD.filter(id => id !== "surefire_xc3") },
    { id: "sig_p226_xfive_us", brand_id: "sig", name: "SIG P226-XFIVE/LEGION (2022 US VERSION)", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD.filter(id => id !== "surefire_xc3") },
    { id: "sig_p226r", brand_id: "sig", name: "Sig P226 (FITS: SAO Legion, P226 Sig Rail, DOES NOT FIT XFIVE LEGION)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p229", brand_id: "sig", name: "Sig P229 (9mm Only)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p238", brand_id: "sig", name: "Sig P238", supported_lights: [] },
    { id: "sig_p320_full", brand_id: "sig", name: "Sig P320 FS (FITS: Sig P320 Full Size, M17, XCARRY Series Grip Modules)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p320c", brand_id: "sig", name: "Sig P320 C (FITS: XCARRY, XCOMPACT, M18, Sig 320C TAC OPS)", qs_nlb_rh: true, supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p320_x5", brand_id: "sig", name: "Sig P320 X5/Legion", qs_nlb_rh: true, supported_lights: [...LIGHT_GROUPS.UNIVERSAL_STD, "sig_foxtrot2r"] },
    { id: "sig_p320_xten", brand_id: "sig", name: "Sig P320-XTEN", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p320_xten_comp", brand_id: "sig", name: "Sig P320-XTEN COMP", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sig_p365", brand_id: "sig", name: "Sig P365/P365X (DOES NOT FIT X-MACRO)", supported_lights: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p365xl", brand_id: "sig", name: "Sig P365 XL", supported_lights: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p365_legion", brand_id: "sig", name: "Sig P365-AXG Black/Legion (GEN 2 ONLY)", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHT_GROUPS.SUB_SIG_MACRO },
    { id: "sig_p365_macro", brand_id: "sig", name: "Sig P365 X-Macro (Fits Tacops Models)", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: LIGHT_GROUPS.SUB_SIG_MACRO },
    { id: "sig_p365_fuse", brand_id: "sig", name: "Sig P365 FUSE", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [...LIGHT_GROUPS.SUB_SIG_MACRO, "tlr7"] },
    { id: "sig_p365_lima", brand_id: "sig", name: "Sig P365 W/Lima", supported_lights: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p365_foxtrot", brand_id: "sig", name: "Sig P365 w/Foxtrot 365", supported_lights: LIGHT_GROUPS.SUB_SIG },
    { id: "sig_p938", brand_id: "sig", name: "Sig P938", supported_lights: [] },

    // SMITH & WESSON
    { id: "sw_mp2_10_4", brand_id: "sw", name: "S&W M&P 2.0 10mm 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_10_46", brand_id: "sw", name: "S&W M&P 2.0 10mm 4.6\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_9_36", brand_id: "sw", name: "S&W M&P 2.0 9/40 3.6\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_9_4", brand_id: "sw", name: "S&W M&P 2.0 9/40 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_9_425", brand_id: "sw", name: "S&W M&P 2.0 9/40 4.25\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_9_5", brand_id: "sw", name: "S&W M&P 2.0 9/40 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    // M&P 2.0 METAL / STEEL FRAME - flags mirror the polymer 2.0 entries above
    { id: "sw_mp2_metal_9_36", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 3.6\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_metal_9_4", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_metal_9_425", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 4.25\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp2_metal_9_5", brand_id: "sw", name: "S&W M&P 2.0 Metal (Steel Frame) 9/40 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp_45_full", brand_id: "sw", name: "S&W M&P Full Size 45", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp_45_compact", brand_id: "sw", name: "S&W M&P Compact 45", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp1_425", brand_id: "sw", name: "S&W M&P 1.0 9mm/40cal (4.25\")", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_mp1_c", brand_id: "sw", name: "S&W M&P 1.0 9mm/40cal Compact", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sw_shield_9_ez", brand_id: "sw", name: "S&W M&P Shield 9mm EZ", supported_lights: LIGHT_GROUPS.SUB_1913 },
    { id: "sw_shield_380_ez", brand_id: "sw", name: "S&W M&P Shield 380 EZ", supported_lights: LIGHT_GROUPS.SUB_1913 },
    { id: "sw_shield_940", brand_id: "sw", name: "S&W M&P Shield 9/40 (Fits 2.0)", supported_lights: [] },
    { id: "sw_shield_45", brand_id: "sw", name: "S&W M&P Shield 45 (Fits 2.0)", supported_lights: [] },
    { id: "sw_shield_plus", brand_id: "sw", name: "S&W M&P Shield Plus", supported_lights: LIGHT_GROUPS.TLR6_ONLY },
    { id: "sw_bodyguard_laser", brand_id: "sw", name: "S&W M&P Bodyguard 380 w/ Red Laser", supported_lights: [] },
    { id: "sw_bodyguard_no_laser", brand_id: "sw", name: "S&W M&P Bodyguard 380 (No Laser)", supported_lights: [] },

    // SPHINX
    { id: "sphinx_sdp", brand_id: "sphinx", name: "SPHINX SDP Compact", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // SPRINGFIELD
    { id: "xd_mod2", brand_id: "springfield", name: "Springfield XD MOD2 3.3\" 9/40", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "xd_sub", brand_id: "springfield", name: "Springfield XD 9/40 3\" Subcompact", supported_lights: [] },
    { id: "xd_4", brand_id: "springfield", name: "Springfield XD 9/40 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "xd_5", brand_id: "springfield", name: "Springfield XD 9/40 Tactical 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "xd_45_4", brand_id: "springfield", name: "Springfield XD 45", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "sp_xd45_5", brand_id: "springfield", name: "Springfield XD 45 Tactical 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "xds_33", brand_id: "springfield", name: "Springfield XDS 9mm 40 45 ACP 3.3", supported_lights: [] },
    { id: "xds_4", brand_id: "springfield", name: "Springfield XDS 9mm 40 45 ACP 4", supported_lights: [] },
    { id: "xdm_38", brand_id: "springfield", name: "Springfield XDM 3.8", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // STACCATO 
    // Quick ship only: right hand, X300 U-A/B or no light. Left hand was
    // custom lead time only, so it is no longer offered on these models.
    { id: "staccato_c2", brand_id: "staccato", name: "Staccato C2", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], right_hand_only: true },
    { id: "staccato_p", brand_id: "staccato", name: "Staccato P", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], right_hand_only: true },
    { id: "staccato_xc", brand_id: "staccato", name: "Staccato XC", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], right_hand_only: true },
    { id: "staccato_xl", brand_id: "staccato", name: "Staccato XL", qs_nlb_rh: true, qs_lb_rh: ["x300u_a", "x300u_b"], supported_lights: ["x300u_a", "x300u_b"], right_hand_only: true },

    // STEYR
    { id: "steyr_atd_4", brand_id: "steyr", name: "Steyr ATD 4\"", qs_nlb_rh: true, qs_nlb_lh: true, supported_lights: [] },
    { id: "steyr_m9a1", brand_id: "steyr", name: "Steyr M9-A1", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // TAURUS
    { id: "taurus_pt111", brand_id: "taurus", name: "Taurus PT111 G2", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },

    // WALTHER
    { id: "walther_ccp", brand_id: "walther", name: "Walther CCP 9/40", supported_lights: [] },
    { id: "walther_pdp_4", brand_id: "walther", name: "Walther PDP Compact/ Full size 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_pdp_45", brand_id: "walther", name: "Walther PDP Full Size 4.5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_pdp_5", brand_id: "walther", name: "Walther PDP Full size 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_ppq_4", brand_id: "walther", name: "Walther PPQ M2 4\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_ppq_5", brand_id: "walther", name: "Walther PPQ M2 5\"", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_pps_m1", brand_id: "walther", name: "Walther PPS M1", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD },
    { id: "walther_pps_m2", brand_id: "walther", name: "Walther PPS M2 9/40", supported_lights: LIGHT_GROUPS.UNIVERSAL_STD }
  ],

  // --- LIGHTS ---
  lights: [
    { id: "inforce_apl", name: "Inforce APL" },
    { id: "inforce_aplc_glock", name: "Inforce APLc (Glock / P-10C / P-01)" },
    { id: "inforce_aplc_uni", name: "Inforce APLc (Universal)" },
    { id: "inforce_apl_3", name: "Inforce APL 3.0" },
    { id: "inforce_wild1", name: "Inforce WILD 1" },
    { id: "olight_pl_mini", name: "OLight PL-Mini" },
    { id: "olight_pl_mini2", name: "OLight PL-Mini 2" },
    { id: "olight_pl2", name: "OLight PL-2" },
    { id: "olight_pl_pro", name: "OLight PL-Pro" },
    { id: "sig_foxtrot1x", name: "Sig Foxtrot1X" },
    { id: "sig_foxtrot2r", name: "Sig Foxtrot2R" },
    { id: "surefire_xc1b", name: "Surefire XC1-B" },
    { id: "surefire_xc1c", name: "Surefire XC1-C" },
    { id: "surefire_xc3", name: "Surefire XC3" },
    { id: "surefire_xsc", name: "Surefire XSC-365" },
    { id: "surefire_xsc_b", name: "Surefire XSC-B" },
    { id: "surefire_xsc_a", name: "Surefire XSC-A" },
    { id: "x300u_a", name: "Surefire X300 U / T (A)" },
    { id: "x300u_b", name: "Surefire X300 U / T (B)" },
    { id: "tlr1", name: "Streamlight TLR-1 / HL" },
    { id: "tlr1_hlx", name: "Streamlight TLR-1 HL-X" },
    { id: "tlr7_hlx", name: "Streamlight TLR-7 HL-X" },
    { id: "tlr7", name: "Streamlight TLR-7 / 7A / 7X" },
    { id: "tlr7_sub_1913", name: "Streamlight TLR-7 SUB / HL-X SUB (1913)" },
    { id: "tlr7_sub_glock", name: "Streamlight TLR-7 SUB / HL-X SUB (G43X / 48)" },
    { id: "tlr7_sub_p365", name: "Streamlight TLR-7 SUB / HL-X SUB (P365)" },
    { id: "tlr6", name: "Streamlight TLR-6" }
  ],

  // --- OPTIONS ---
  hands: [ { id: "right", name: "Right Handed" }, { id: "left", name: "Left Handed" } ],
  
  lightbearing_options: [ 
      { id: "no", name: "Non-Lightbearing" }, 
      { id: "yes", name: "Lightbearing" } 
  ],

  cants: [
    { id: "no_cant", name: "No Cant (Standard)", price: 0 },
    { id: "10_degree", name: "10° Cant", price: 0 },
  ],

  // --- COLORS (Mapped for $20 markup) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 20),

 // --- MOUNTS ---
  mounts: [
    { 
      id: "injection_loop_150", 
      name: "1.5\" Injection Molded Belt Loops", 
      price: 0, 
      img_layer_mount: "/anr-builder/images/mounts/injection_loop_150_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/injection_loop_150_back.png",
      description: "Standard 1.5 inch belt loops. Durable and reliable."
    },
    { 
      id: "injection_loop_175", 
      name: "1.75\" Injection Molded Belt Loops", 
      price: 0, 
      img_layer_mount: "/anr-builder/images/mounts/injection_loop_175_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/injection_loop_175_back.png",
      description: "Standard 1.75 inch belt loops. Durable and reliable."
    },
    { 
      id: "pancake_150", 
      name: "1.5\" Pancake Loops", 
      price: 2.00, 
      img_layer_mount: "/anr-builder/images/mounts/pancake_150_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/pancake_150_back.png", 
      description: "Curved loops designed to pull the holster tighter to the body for better concealment."
    },
    { 
      id: "pancake_175", 
      name: "1.75\" Pancake Loops", 
      price: 2.00, 
      img_layer_mount: "/anr-builder/images/mounts/pancake_175_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/pancake_175_back.png",
      description: "Curved loops designed to pull the holster tighter to the body. Fits 1.75\" belts."
    },
    { 
      id: "speed_clips_150", 
      name: "1.5\" Speed Clips", 
      price: 2.00, 
      img_layer_mount: "/anr-builder/images/mounts/speed_clips_150_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/speed_clips_150_back.png",
      description: "Open-ended clips that allow you to put the holster on or take it off without undoing your belt."
    },
    { 
      id: "speed_clips_175", 
      name: "1.75\" Speed Clips", 
      price: 2.00, 
      img_layer_mount: "/anr-builder/images/mounts/speed_clips_175_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/speed_clips_175_back.png", 
      description: "Open-ended clips for 1.75\" belts. Easy on/off convenience."
    }
  ],

  // --- OPTIC CUT OPTIONS ---
  optic_options: [
    { 
      id: "yes", 
      name: "Yes - Standard Optic Cut", 
      description: "Fits RMR, Holosun 407/507c/k, Vortex Venom, and most standard red dots."
    },
    { 
      id: "rmr_hd", 
      name: "Yes - Trijicon RMR HD", 
      description: "Specific deep cut required for the forward overhang of the RMR HD sensor."
    },
    { 
      id: "sro", 
      name: "Yes - Trijicon SRO", 
      description: "Specific deep cut required to clear the large circular lens housing of the SRO."
    }
  ],

  // --- CANT OPTIONS ---
  cant_options: [
    { 
      id: "none", 
      name: "Straight Drop (0°)", 
      description: "Vertical draw. Best for OWB open carry or range use."
    },
    { 
      id: "10_deg", 
      name: "10 Degree Cant", 
      description: "Tilts the grip forward slightly. Helps reduce printing if carrying OWB concealed."
    }
  ],

  // --- MAG CARRIER ADDONS ---
  mag_carriers: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "yes_1", name: "Yes Add 1", price: 29.99 },
    { id: "yes_2", name: "Yes Add 2", price: 49.99 },
    { id: "mystery", name: "1 Mystery Limited Edition Kydex Pattern", price: 29.99 }
  ],

  // --- ADD-ON MAG MOUNTS (LOWER PRICING) ---
  mag_mounts: [
    { id: "clip_15", name: "1.5\" Injection Molded Clip", price: 0 },
    { id: "clip_175", name: "1.75\" Injection Molded Clip", price: 0 },
    { id: "dcc_ANRlogo", name: "1.5\" DCC Monoblock ANR Logo", price: 4.99 },
    { id: "dcc_nologo", name: "1.5\" DCC Monoblock No Logo", price: 4.49 },
    { id: "dcc_FDElogo", name: "1.5\" DCC Monoblock FDE w/ Logo", price: 4.99 },
    { id: "dcc_TOPOlogo", name: "1.5\" DCC Monoblock Topographical", price: 5.49 },
    { id: "neomag", name: "Neomag Alias TPost", price: 15.99 },
    { id: "neomag_receiver", name: "Neomag Alias TPost and Neomag Alias Belt Receiver", price: 49.99 }
  ],

  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};